/**
 * List of events used by booking box widget
 *
 */
export const bookingBox = {
  COLLAPSE_OPEN: 'BookingBox.Open',
  COLLAPSE_CLOSE: 'BookingBox.Close'
}
